import Client from "./Clients/AxiosClient";
const resource = "/api/user";

export default {
    getStaff(payload) {
        return Client.get(`/api/staff/logged/${payload.id}`);
    },
    // Asks the API whether the token in localStorage is still valid. Answers 401 once the session
    // has been revoked (or the token has expired), which AxiosClient turns into a forced sign out.
    getCurrentSession() {
        return Client.get(`/api/Session/current`);
    },
}
